export const required = (value: string | undefined): string | undefined => {
  // eslint-disable-next-line no-undefined, @typescript-eslint/strict-boolean-expressions
  return value ? undefined : 'Required'
}
